import React from 'react';

import { isSection, Section } from '@ael/core-api';
import { Button, ButtonVariant } from '@ael/shared-components-library';
import classNames from 'classnames';
import { List } from 'immutable';

import './split-content.scss';
import {getItemByIdSelector} from '../../../store/reducers/items/itemsSelectors';
import {useStudentSelector} from '../../../store/selectors/useStudentSelector';

export interface SplitContentProps {
  items: List<string>;
  onGoToSection: (section: Section) => void;
}

export const SplitContent: React.FC<SplitContentProps> = (props: SplitContentProps) => {
  const getItemById = useStudentSelector(getItemByIdSelector);

  return (
    <div className={classNames('split-content__section')}>
      {props.items.map((itemId: string) => {
        const item = getItemById(itemId);

        if (!isSection(item)) {
          return null;
        }
        return (
          <Button
            key={itemId}
            variant={ButtonVariant.PRIMARY}
            onClick={() => props.onGoToSection(item)}
            fullWidth={true}
          >
            {item.title}
          </Button>
        );
      })}
    </div>
  );
};
